import { PLATFORM_FEATURES } from '@/lib/constants/features';
import { hasFeature } from '@/lib/utils/features';
import { useSessionStore } from '@/store/sessionStore';

export function useFeatures() {
  const user = useSessionStore(s => s.user);

  // Delegates to `hasFeature` so this hook and the router guards that cannot
  // call it (`beforeLoad` runs outside React) share one predicate — the same
  // split `usePermissions`/`ensurePermissions` use around their `build()`.
  function isFeatureEnabled(featureId: string): boolean {
    return hasFeature(user, featureId);
  }

  return {
    isFeatureEnabled,
    isTracingAiEnabled: isFeatureEnabled(PLATFORM_FEATURES.TRACING_AI),
    isAuditAiEnabled: isFeatureEnabled(PLATFORM_FEATURES.AUDIT_AI),
    isCapaV2Enabled: isFeatureEnabled(PLATFORM_FEATURES.CAPA_V2),
    isCascadeTracingEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.CASCADE_TRACING,
    ),
    isCascadeTracingCollaborationEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.CASCADE_TRACING_COLLABORATION,
    ),
    isCertifiedMaterialsManagementEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.CERTIFIED_MATERIALS_MANAGEMENT,
    ),
    isCompanyProfilesEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.COMPANY_PROFILES,
    ),
    isEntityScreeningV2Enabled: isFeatureEnabled(
      PLATFORM_FEATURES.ENTITY_SCREENING_V2,
    ),
    isItcIntegrationEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.ITC_INTEGRATION,
    ),
    isKharonEntityListEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.KHARON_ENTITY_LIST,
    ),
    isKharonV2Enabled: isFeatureEnabled(PLATFORM_FEATURES.KHARON_V2),
    isProductMappingEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.PRODUCT_MAPPING,
    ),
    isRiskAnalysisV3Enabled: isFeatureEnabled(
      PLATFORM_FEATURES.RISK_ANALYSIS_V3,
    ),
    isSlcpAssessmentEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SLCP_ASSESSMENT,
    ),
    isSocialScoreEnabled: isFeatureEnabled(PLATFORM_FEATURES.SOCIAL_SCORE),
    isSlcpActiveHostEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SLCP_ACTIVE_HOST,
    ),
    isSupplyChainMappingProductStoryEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SUPPLY_CHAIN_MAPPING_PRODUCT_STORY,
    ),
    isViewNetworkUsersInfoEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.VIEW_NETWORK_USERS_INFO,
    ),
    isDropBoxEnabled: isFeatureEnabled(PLATFORM_FEATURES.DROP_BOX),
    isSupplierQuestionnaireEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.SUPPLIER_QUESTIONNAIRE,
    ),
    isOrdersHubEnabled: isFeatureEnabled(PLATFORM_FEATURES.ORDERS_HUB),
    isAutomationRulesNlDraftEnabled: isFeatureEnabled(
      PLATFORM_FEATURES.AUTOMATION_RULES_NL_DRAFT,
    ),
  };
}
